import { secondsToDhms } from 'helpers';
import useAxios from 'hooks/useAxios';
import { formatDateToLocal } from 'services/metrics';
import dayjs from 'dayjs';

export const getSessions = async (limit = 20, page = 1, filters = {}) => {
  const api = useAxios();

  // Build params object with filter support
  const params = {
    limit: limit,
    page: page
  };

  // Date filters (placeholder - backend may not support yet)
  if (filters.startDate) {
    params.startDate = dayjs(filters.startDate).toISOString();
  }
  if (filters.endDate) {
    params.endDate = dayjs(filters.endDate).toISOString();
  }

  // Entity filters
  if (filters.clientId) {
    params.clientId = filters.clientId;
  }
  if (filters.operatorId) {
    params.operatorId = filters.operatorId;
  }
  if (filters.brandId) {
    params.brandId = filters.brandId;
  }

  // Game filter
  if (filters.gameType) {
    params.gameType = filters.gameType;
  }

  // Country filter (placeholder - backend may not support yet)
  if (filters.country) {
    params.country = filters.country;
  }

  // Player search (placeholder - backend may not support yet)
  if (filters.search) {
    params.search = filters.search;
  }

  try {
    const params = {
      limit: limit,
      page: page
    };
    const timeFilter = [];
    if (filters?.startDate) {
      timeFilter.push(`$gte:${new Date(filters.startDate).toISOString()}`);
    }
    if (filters?.endDate) {
      timeFilter.push(`$lte:${new Date(filters.endDate).toISOString()}`);
    }
    if (timeFilter.length) {
      params['filter.createdAt'] = timeFilter;
    }
    if (filters?.clientId) {
      params['filter.game.client.id'] = `$eq:${filters.clientId}`;
    }
    if (filters?.gameId) {
      params['filter.game.id'] = `$eq:${filters.gameId}`;
    }
    const unformattedData = await api.get('/session', {
      params
    });
    return {
      data: unformattedData.data.data.map((x) => {
        return {
          ...x,
          gameMode: x.game.game,
          game: x.game.name,
          clientName: x.clientName || x.game?.client?.name || '-',
          duration: x?.duration ? secondsToDhms(x.duration) : 'Ongoing',
          playerUsername: x.player.username,
          sessionDate: formatDateToLocal(x.createdAt),
          betRange: x.betLimit,
          sessionCountry: x.country,
          playerNickname: x.player.nickname
        };
      }),
      meta: unformattedData.data.meta
    };
  } catch (err) {
    console.error(err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};
